import AdvisorPreview from 'sly/hubPage/components/HubDynamicContent/DynamicAdvisors/AdvisorPreview';
import { DynamicAdvisorsProps } from 'sly/hubPage/components/HubDynamicContent/DynamicAdvisors/DynamicAdvisors.types';
import CommunityAdvisorWrapper from 'sly/hubPage/components/HubDynamicContent/SharedComponents/CommunityAdvisorWrapper';

export default function DynamicAdvisors({ advisors }: DynamicAdvisorsProps) {
  if (!advisors) {
    return null;
  }
  return (
    <CommunityAdvisorWrapper>
      {advisors.map((item) => (
        <AdvisorPreview key={item.id} item={item} />
      ))}
    </CommunityAdvisorWrapper>
  );
}
